<h1 mat-dialog-title>Random Avatar</h1>
<div mat-dialog-content>
    <img [src]="'https://cdn2.tda.website/beehive/20200826/' + Avatar">
</div>
<div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button mat-dialog-close="random">Random Again</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes! Save this one.</button>
</div>